<script>

import {forEach} from 'lodash';
import TimelineItem from 'top20common/components/timeline/TimelineItem';

import TokenTimelineItem from './TokenTimelineItem';

const markersMapping = {
  default: TimelineItem,
  token: TokenTimelineItem
};

export default {
  render(createElement) {
    return createElement(markersMapping[this.markerStyle], {
      props: this.props,
      scopedSlots: this.slots
    });
  },
  props: {
    props: Object,
    markerStyle: {
      type: String,
      default: 'default',
      validator: value => Object.keys(markersMapping).includes(value)
    }
  },
  computed: {
    slots() {
      let slots = {};
      forEach(this.$slots, (slot, key) => {
        slots[key] = () => slot;
      });
      return slots;
    }
  }
};
</script>
